///productbillofmaterialcomponentsupplierproduct/list
export const GET_BOM_COMPONENT_SUPPLIER_PRODUCT_LIST =
  "GET_BOM_COMPONENT_SUPPLIER_PRODUCT_LIST";
export const GET_BOM_COMPONENT_SUPPLIER_PRODUCT_LIST_SUCCESS =
  "GET_BOM_COMPONENT_SUPPLIER_PRODUCT_LIST_SUCCESS";
export const GET_BOM_COMPONENT_SUPPLIER_PRODUCT_LIST_FAILURE =
  "GET_BOM_COMPONENT_SUPPLIER_PRODUCT_LIST_FAILURE";

///productbillofmaterialcomponentsupplierproduct/data
export const GET_BOM_COMPONENT_SUPPLIER_PRODUCT_DATA =
  "GET_BOM_COMPONENT_SUPPLIER_PRODUCT_DATA";
export const GET_BOM_COMPONENT_SUPPLIER_PRODUCT_DATA_SUCCESS =
  "GET_BOM_COMPONENT_SUPPLIER_PRODUCT_DATA_SUCCESS";
export const GET_BOM_COMPONENT_SUPPLIER_PRODUCT_DATA_FAILURE =
  "GET_BOM_COMPONENT_SUPPLIER_PRODUCT_DATA_FAILURE";

///productbillofmaterialcomponentsupplierproduct/search
export const SEARCH_BOM_COMPONENT_SUPPLIER_PRODUCT =
  "SEARCH_BOM_COMPONENT_SUPPLIER_PRODUCT";
export const SEARCH_BOM_COMPONENT_SUPPLIER_PRODUCT_SUCCESS =
  "SEARCH_BOM_COMPONENT_SUPPLIER_PRODUCT_SUCCESS";
export const SEARCH_BOM_COMPONENT_SUPPLIER_PRODUCT_FAILURE =
  "SEARCH_BOM_COMPONENT_SUPPLIER_PRODUCT_FAILURE";

///productbillofmaterialcomponentsupplierproduct/create
export const CREATE_BOM_COMPONENT_SUPPLIER_PRODUCT =
  "CREATE_BOM_COMPONENT_SUPPLIER_PRODUCT";
export const CREATE_BOM_COMPONENT_SUPPLIER_PRODUCT_SUCCESS =
  "CREATE_BOM_COMPONENT_SUPPLIER_PRODUCT_SUCCESS";
export const CREATE_BOM_COMPONENT_SUPPLIER_PRODUCT_FAILURE =
  "CREATE_BOM_COMPONENT_SUPPLIER_PRODUCT_FAILURE";

///productbillofmaterialcomponentsupplierproduct/update
export const UPDATE_BOM_COMPONENT_SUPPLIER_PRODUCT =
  "UPDATE_BOM_COMPONENT_SUPPLIER_PRODUCT";
export const UPDATE_BOM_COMPONENT_SUPPLIER_PRODUCT_SUCCESS =
  "UPDATE_BOM_COMPONENT_SUPPLIER_PRODUCT_SUCCESS";
export const UPDATE_BOM_COMPONENT_SUPPLIER_PRODUCT_FAILURE =
  "UPDATE_BOM_COMPONENT_SUPPLIER_PRODUCT_FAILURE";

///productbillofmaterialcomponentsupplierproduct/delete
export const DELETE_BOM_COMPONENT_SUPPLIER_PRODUCT =
  "DELETE_BOM_COMPONENT_SUPPLIER_PRODUCT";
export const DELETE_BOM_COMPONENT_SUPPLIER_PRODUCT_SUCCESS =
  "DELETE_BOM_COMPONENT_SUPPLIER_PRODUCT_SUCCESS";
export const DELETE_BOM_COMPONENT_SUPPLIER_PRODUCT_FAILURE =
  "DELETE_BOM_COMPONENT_SUPPLIER_PRODUCT_FAILURE";

///productbillofmaterialcomponent/list
export const GET_BOM_COMPONENT_LIST = "GET_BOM_COMPONENT_LIST";
export const GET_BOM_COMPONENT_LIST_SUCCESS = "GET_BOM_COMPONENT_LIST_SUCCESS";
export const GET_BOM_COMPONENT_LIST_FAILURE = "GET_BOM_COMPONENT_LIST_FAILURE";

///productbillofmaterialcomponent/data
export const GET_BOM_COMPONENT_DATA = "GET_BOM_COMPONENT_DATA";
export const GET_BOM_COMPONENT_DATA_SUCCESS = "GET_BOM_COMPONENT_DATA_SUCCESS";
export const GET_BOM_COMPONENT_DATA_FAILURE = "GET_BOM_COMPONENT_DATA_FAILURE";

///productbillofmaterialcomponent/search
export const SEARCH_BOM_COMPONENT = "SEARCH_BOM_COMPONENT";
export const SEARCH_BOM_COMPONENT_SUCCESS = "SEARCH_BOM_COMPONENT_SUCCESS";
export const SEARCH_BOM_COMPONENT_FAILURE = "SEARCH_BOM_COMPONENT_FAILURE";

///productbillofmaterialcomponent/create
export const CREATE_BOM_COMPONENT = "CREATE_BOM_COMPONENT";
export const CREATE_BOM_COMPONENT_SUCCESS = "CREATE_BOM_COMPONENT_SUCCESS";
export const CREATE_BOM_COMPONENT_FAILURE = "CREATE_BOM_COMPONENT_FAILURE";

///productbillofmaterialcomponent/update
export const UPDATE_BOM_COMPONENT = "UPDATE_BOM_COMPONENT";
export const UPDATE_BOM_COMPONENT_SUCCESS = "UPDATE_BOM_COMPONENT_SUCCESS";
export const UPDATE_BOM_COMPONENT_FAILURE = "UPDATE_BOM_COMPONENT_FAILURE";

///productbillofmaterialcomponent/delete
export const DELETE_BOM_COMPONENT = "DELETE_BOM_COMPONENT";
export const DELETE_BOM_COMPONENT_SUCCESS = "DELETE_BOM_COMPONENT_SUCCESS";
export const DELETE_BOM_COMPONENT_FAILURE = "DELETE_BOM_COMPONENT_FAILURE";

///productbillofmaterial/list
///salesorder/billofmaterials/:id (aggregated BOM for a sales order)
export const GET_SALES_ORDER_BILL_OF_MATERIALS =
  "GET_SALES_ORDER_BILL_OF_MATERIALS";
export const GET_SALES_ORDER_BILL_OF_MATERIALS_SUCCESS =
  "GET_SALES_ORDER_BILL_OF_MATERIALS_SUCCESS";
export const GET_SALES_ORDER_BILL_OF_MATERIALS_FAILURE =
  "GET_SALES_ORDER_BILL_OF_MATERIALS_FAILURE";

export const GET_BOM_LIST = "GET_BOM_LIST";
export const GET_BOM_LIST_SUCCESS = "GET_BOM_LIST_SUCCESS";
export const GET_BOM_LIST_FAILURE = "GET_BOM_LIST_FAILURE";

///productbillofmaterial/data
export const GET_BOM_DATA = "GET_BOM_DATA";
export const GET_BOM_DATA_SUCCESS = "GET_BOM_DATA_SUCCESS";
export const GET_BOM_DATA_FAILURE = "GET_BOM_DATA_FAILURE";

///productbillofmaterial/search
export const SEARCH_BOM = "SEARCH_BOM";
export const SEARCH_BOM_SUCCESS = "SEARCH_BOM_SUCCESS";
export const SEARCH_BOM_FAILURE = "SEARCH_BOM_FAILURE";
///productbillofmaterial/create
export const CREATE_BOM = "CREATE_BOM";
export const CREATE_BOM_SUCCESS = "CREATE_BOM_SUCCESS";
export const CREATE_BOM_FAILURE = "CREATE_BOM_FAILURE";
///productbillofmaterial/update
export const UPDATE_BOM = "UPDATE_BOM";
export const UPDATE_BOM_SUCCESS = "UPDATE_BOM_SUCCESS";
export const UPDATE_BOM_FAILURE = "UPDATE_BOM_FAILURE";
///productbillofmaterial/delete
export const DELETE_BOM = "DELETE_BOM";
export const DELETE_BOM_SUCCESS = "DELETE_BOM_SUCCESS";
export const DELETE_BOM_FAILURE = "DELETE_BOM_FAILURE";

///productbillofmaterial/createversion
export const CREATE_BOM_VERSION = "CREATE_BOM_VERSION";
export const CREATE_BOM_VERSION_SUCCESS = "CREATE_BOM_VERSION_SUCCESS";
export const CREATE_BOM_VERSION_FAILURE = "CREATE_BOM_VERSION_FAILURE";

///productbillofmaterial/clone
export const CLONE_BOM = "CLONE_BOM";
export const CLONE_BOM_SUCCESS = "CLONE_BOM_SUCCESS";
export const CLONE_BOM_FAILURE = "CLONE_BOM_FAILURE";
///producttoproductbillofmaterial/search
export const SEARCH_PRODUCT_TO_BOM = "SEARCH_PRODUCT_TO_BOM";
export const SEARCH_PRODUCT_TO_BOM_SUCCESS = "SEARCH_PRODUCT_TO_BOM_SUCCESS";
export const SEARCH_PRODUCT_TO_BOM_FAILURE = "SEARCH_PRODUCT_TO_BOM_FAILURE";

///productbillofmaterialtoproductrule/search (map a BOM to products via lookup)
export const SEARCH_PRODUCT_BOM_TO_PRODUCT_RULE =
  "SEARCH_PRODUCT_BOM_TO_PRODUCT_RULE";
export const SEARCH_PRODUCT_BOM_TO_PRODUCT_RULE_SUCCESS =
  "SEARCH_PRODUCT_BOM_TO_PRODUCT_RULE_SUCCESS";
export const SEARCH_PRODUCT_BOM_TO_PRODUCT_RULE_FAILURE =
  "SEARCH_PRODUCT_BOM_TO_PRODUCT_RULE_FAILURE";
